import { render } from "./wfm-timestamp.vue?vue&type=template&id=1a95251c&scoped=true"
import script from "./wfm-timestamp.vue?vue&type=script&lang=js"
export * from "./wfm-timestamp.vue?vue&type=script&lang=js"

import "./wfm-timestamp.vue?vue&type=style&index=0&id=1a95251c&lang=css"
import "./wfm-timestamp.vue?vue&type=style&index=1&id=1a95251c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a95251c"]])

export default __exports__